const units = ['b', 'k', 'm', 'g', 't', 'p', 'e', 'z', 'y'] as const;
const multipliers = units.map((_, i) => 1024 ** i);

type ToBytes = (value: number, prefix: typeof units[number]) => number;

export const toBytes: ToBytes = (value, prefix) => value * multipliers[units.indexOf(prefix)];
